import React from "react";
import GoogleLoader from "../assets/Loader/GoogleSvgLoader/GoogleLoader";
import {
  carRideIcon,
  creditIcon,
  refundIcon,
  subscriptionIcon,
} from "../assets/images";

const getTransactionTypeIcon = (title: string): JSX.Element => {
  switch (title) {
    case "Service":
      return <img src={carRideIcon} alt="service" />;
    case "Subscription":
      return <img src={subscriptionIcon} alt="subscription" />;
    case "Refund":
      return <img src={refundIcon} alt="refund" />;
    case "CreditCard":
      return <img src={creditIcon} alt="credit" />;
    default:
      return <GoogleLoader />;
  }
};

export default getTransactionTypeIcon;
